export type PostponeJobType = {
  postponeJobId: string;
  name?: string | null;
  postponedUntil?: string | null;
  postponeReason?: string | null;
  postponedAt: string;
  postponedBy: string;
};
